<section class="vertical-stepper-header-container">
    <div class="stepper-header always-flex">
        <div class="stepper-current-state">
            <h2 class="mat-headline-2">
                <mat-icon class="badge-aligned" [matBadge]="(index() ?? 0) + 1" matBadgeOverlap="false"
                    [matBadgePosition]="'below before'"></mat-icon>
                <span class="label-text">{{stepLabel()}}</span>
            </h2>
            <span class="sr-only">Step {{(index() ?? 0) +1}} of {{stepCount()}}</span>
            @if ( (stepCount() ?? 0) > ((index() ?? 0) + 1 )) {
            <button hidden=true color="primary" mat-flat-button matStepperNext type="button">
                Next: {{nextStepLabel()}}</button>
            }
        </div>
        <div class="stepper-pager always-flex flex-end">
            <button mat-icon-button type='button' [disabled]="index() === 0" matStepperPrevious aria-label="Return to previous step">
                <mat-icon>{{( index() != 0 ? 'keyboard_double_arrow_left' : '')}}</mat-icon>
            </button>
            <span class=""> {{(index() ?? 0)  + 1}} of {{stepCount()}} </span>
            <button mat-icon-button type='button' [disabled]="stepCount() == ((index() ?? 0)  + 1)" matStepperNext
                aria-label="Proceed to next step">
                <mat-icon>{{((stepCount() ?? 0 ) != ((index() ?? 0)  + 1) ? 'keyboard_double_arrow_right' : '')}}</mat-icon>
            </button>
        </div>
    </div>
</section>